import React, { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@material-ui/core/styles';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/style.css';
import './assets/css/dev-style.css';
import './assets/css/zoomvideo.css';
import { Loader, Spinner } from 'layout';
import Routes from './shared/AppRouting';
import { portalTheme } from './themes/App.theme';
import ErrorBoundary from './shared/ErrorBoundary';

const App: React.FC = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <ToastContainer limit={5} />
            <Loader />
            <ThemeProvider theme={portalTheme}>
                <ErrorBoundary>
                    <Routes />
                </ErrorBoundary>
            </ThemeProvider>
        </Suspense>
    );
};

export default App;
